<template>
<div class="container">
  <!-- 全市通办服务内容start -->
  <div class="table-view">
    <div class="tabs-wrap mb-40">
      <ul class="tabs">
        <li>
          <p class="tabs-item">湛江全市通办服务内容</p>
        </li>
      </ul>
    </div>
    <ListSelect :selectData="serverType" tip="服务对象" :getItem="selectType" />
    <!-- 全市通办服务内容start -->
    <div class="input-wrap">
      <span class="input-wrap-text">您要办理什么事项？</span>
      <input class="search" type="text" placeholder="请输入事项名称" v-model="keyword" @keyup.enter="search" />
      <i class="icon el-icon-search" @click="search"></i>
    </div>
    <div class="table-wrap" aria-label="提供各种事项服务" wzades="提供各种事项服务">
      <el-table :data="itemList" style="width: 100%">
        <el-table-column label="事项名称">
          <template slot-scope="scope">
            <div class="name"><a href="javascript://" class="name-option" @click="choseItem(scope.row)">{{scope.row.approveName}}</a></div>
          </template>
        </el-table-column>
        <el-table-column  label="事项类型" width="200">
          <template slot-scope="scope">
            {{scope.row.itemTypeName ? scope.row.itemTypeName : '-'}}
          </template>
        </el-table-column>
        <el-table-column label="服务对象" width="250">
          <template slot-scope="scope">
            {{scope.row.serviceObjName ? scope.row.serviceObjName : '-'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="right">
          <template slot-scope="scope">
            <a href="javascript://" class="name-option" @click="choseItem(scope.row)">在线办理</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 全市通办服务内容end -->
    <Pagination :pageIndex="pageIndex" :totalRow="totalRow" :linktoPageCall="linktoPageFunc" :totalPage="totalPage" />
  </div>
  <!-- 全市通办服务内容end -->
  <!-- 选择区县(办事站点)的弹框 -->
  <el-dialog title="请选择办事情景" :visible.sync="showArea" :close-on-click-modal="false" width="600px" class="scenes-area-dialog">
    <div class="one-step clearfix">
      <i class="step-bgm one-step-icon fl"></i>
      <span class="step-title fl">选择办事站点</span>
      <span class="step-tips"><i class="step-tips-icon"></i>不同办事站点的流程和材料可能存在差异</span>
    </div>
    <div class="area-list">
      <div :class="['chose-area-item', {'active': item.areaSeq == choseAreaSeq}]" v-for="(item, i) in areaList" :key="i" @click="chooseAreaActive(item)">
        {{item.areaName}}
        <span v-if="item.areaSeq == choseAreaSeq">
          <i class="el-icon-check active-icon"></i>
        </span>
      </div>
    </div>
    <div class="two-step clearfix">
      <i class="step-bgm two-step-icon fl"></i>
      <span class="step-title fl">{{ choseApproveName }}</span>
    </div>
    <div class="arrpove-list">
      <div class="arrpove-items" v-for="(item, i) in wholeCityItemList" :key="i">
        <div class="arrpove-name">{{ item.approveName }}</div>
        <div class="arrpove-btns">
          <span @click="turnPage(item, 'detail')">查看指南</span>
          <span @click="turnPage(item)">在线办理</span>
        </div>
      </div>
    </div>
  </el-dialog>
  <!-- 选择部门和办事站点的弹框 -->
  <el-dialog title="请选择办事情景" :visible.sync="showUnitAndArea" :close-on-click-modal="false" width="600px" class="scenes-area-dialog">
    <div class="one-step clearfix">
      <i class="step-bgm one-step-icon fl"></i>
      <span class="step-title fl">选择管理部门</span>
      <span class="step-tips"><i class="step-tips-icon"></i>该事项可多个部门办理</span>
    </div>
    <div class="area-list">
      <div :class="['chose-area-item', {'active': item.areaSeq == chooseUnitSeq}]" v-for="(item, i) in unitList" :key="i" @click="chooseUnit(item)">
        {{item.unitName}}
        <span v-if="item.areaSeq == chooseUnitSeq">
          <i class="el-icon-check active-icon"></i>
        </span>
      </div>
    </div>
    <div class="two-step clearfix">
      <i class="step-bgm two-step-icon fl"></i>
      <span class="step-title fl">选择办事站点</span>
      <span class="step-tips"><i class="step-tips-icon"></i>不同办事站点的流程和材料可能存在差异</span>
    </div>
    <div class="area-list">
      <div :class="['chose-area-item', {'active': item.areaSeq == choseAreaSeq}]" v-for="(item, i) in areaList" :key="i" @click="chooseAreaActive(item)">
        {{item.areaName}}
        <span v-if="item.areaSeq == choseAreaSeq">
          <i class="el-icon-check active-icon"></i>
        </span>
      </div>
    </div>
    <div class="three-step clearfix">
      <i class="step-bgm three-step-icon fl"></i>
      <span class="step-title fl">{{ choseApproveName }}</span>
    </div>
    <div class="arrpove-list">
      <div class="arrpove-items" v-for="(item, i) in wholeCityItemList" :key="i">
        <div class="arrpove-name">{{ item.approveName }}</div>
        <div class="arrpove-btns">
          <span @click="turnPage(item, 'detail')">查看指南</span>
          <span @click="turnPage(item)">在线办理</span>
        </div>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {
  wholeCityItemList,
  wholeCityAreaList,
  wholeCityItemListByArea,
  wholeCityUnitListByApprove
} from '@/assets/utils/controlApi.js';
import ListSelect from '@/components/ListSelect.vue';
import Pagination from '@/components/pagination.vue';
export default {
  data() {
    return {
      itemList: [],
      pageIndex: 1,
      totalRow: 0,
      totalPage: 1,
      keyword: "",
      areaList: [],
      wholeCityItemList: [],
      unitList: [],
      showArea: false,
      showUnitAndArea: false,
      choseAreaSeq: "",
      choseApproveName: "",
      chooseUnitSeq: "",
      chooseUnitCode: "",
      serverType: [{
        id: '',
        name: '全部'
      }, {
        id: '1',
        name: '个人'
      }, {
        id: '2',
        name: '法人'
      }]
    };
  },
  components: {
    ListSelect,
    Pagination
  },
  methods: {
    selectType(serviceObjType) {
      this.serviceObjType = serviceObjType;
      this.getItemList();
    },
    search() {
      this.loadingInstance = this.$loading.service({
        lock: true,
        text: "Loading"
      });
      this.pageIndex = 1;
      this.getItemList();
    },
    //分页回调
    linktoPageFunc(pageIndex) {
      this.pageIndex = pageIndex;
      this.getItemList();
    },
    // 跳转
    turnPage(item, type) {
      if (type == 'detail') {
        let url = 'http://www.gdzwfw.gov.cn/portal/guide/' + item.itemCode;
        window.open(url);
      } else {
        let url = '/ApprApplyWorkPC/apply.html#/bussinessChoose?approveSeq=' + item.approveSeq;
        window.open(url);
      }
    },
    // 选择管理部门
    async chooseUnit(item) {
      this.chooseUnitSeq = item.areaSeq;
      this.chooseUnitCode = item.unitCode;
      // 获取全市通办地区选择列表（只展示区县级）
      let res = await wholeCityAreaList({
        approveName: this.choseApproveName,
        areaSeq: this.chooseUnitSeq
      });
      if (res.status == '200') {
        this.areaList = res.data;
        this.choseAreaSeq = this.areaList[0].areaSeq;
        this.getWholeCityItemListByArea();
      } else {
        this.$message.error(res.desc);
      }
    },
    // 选择所属地
    chooseAreaActive(item) {
      this.choseAreaSeq = item.areaSeq;
      this.getWholeCityItemListByArea();
    },
    /*
    点击事项
      1）如果事项未进行合并，且事项只有一个办理地点，那么在新标签页中打开事项办事指南页面/网上申办页面。
      2）如果事项未进行合并，但事项有多个办理地点，那么弹出对话框选择办事站点。
        其中，办理地点展示的是此事项的全市通办地区。
      3）如果事项有进行合并，那么弹出"选择管理部门和办理地点"。
        其中，管理部门是所有同名事项的实施主体（选择了实施主体也就确定了办理哪一个事项），办理地点展示的是事项的全市通办地区。
    */
    async choseItem(item) {
      this.choseApproveName = item.approveName;
      this.choseAreaSeq = "";
      this.chooseUnitSeq = "";
      // 获取全市通办地区选择列表（只展示区县级）
      let res = await wholeCityAreaList({
        approveName: this.choseApproveName
      });
      if (res.status == '200') {
        this.areaList = res.data;
        console.log("====item==", item)
        if (item.isMulti == 0) { //未合并就是0
          if (this.areaList.length == 1) { //只有一个办理地点
            console.log("只有一个办理地点")
            let url = '/ApprApplyWorkPC/apply.html#/bussinessChoose?approveSeq=' + item.approveSeq;
            window.open(url)
          } else { //有多个办理地点
            this.choseAreaSeq = this.areaList[0].areaSeq;
            await this.getWholeCityItemListByArea();
            this.showArea = true;
          }
        } else { //合并就是1
          console.log("==合并了=")
          this.choseAreaSeq = this.areaList[0].areaSeq;
          await this.getWholeCityUnitListByApprove();
          await this.getWholeCityItemListByArea();
          this.showUnitAndArea = true;
        }
      } else {
        this.$message.error(res.desc);
      }
    },
    // 根据地区流水号获取全市通办事项选择列表
    getWholeCityItemListByArea() {
      return new Promise((resolve) => {
        wholeCityItemListByArea({
          areaSeq: this.choseAreaSeq,
          approveName: this.choseApproveName,
          unitCode: this.chooseUnitCode,
        }).then(res => {
          if (res.status == '200') {
            this.wholeCityItemList = res.data;
            resolve();
          } else {
            this.$message.error(res.desc);
          }
        }).catch(err => {
          console.log(err)
        })
      })
    },
    // 根据事项名称获取全市通办单位选择列表
    getWholeCityUnitListByApprove() {
      return new Promise((resolve) => {
        wholeCityUnitListByApprove({
          approveName: this.choseApproveName
        }).then(res => {
          if (res.status == '200') {
            this.unitList = res.data;
            if (!this.chooseUnitSeq) this.chooseUnitSeq = this.unitList[0].areaSeq;
            if (!this.chooseUnitCode) this.chooseUnitCode = this.unitList[0].unitCode;
            resolve();
          } else {
            this.$message.error(res.desc);
          }
        })
      })
    },
    // 获取全市通办事项列表
    getItemList() {
      wholeCityItemList({
        serviceObjType: this.serviceObjType,
        approveName: this.keyword,
        pageRowNum: 10,
        pageIndex: this.pageIndex || 1
      }).then(res => {
        if (res.status == '200') {
          this.itemList = res.data.dataList;
          this.totalRow = res.data.pageObj.totalRow;
          this.totalPage = res.data.pageObj.totalPage;
          this.pageIndex = res.data.pageObj.pageIndex;
        } else {
          this.$message.error(res.desc);
        }
        this.loadingInstance ? this.loadingInstance.close() : "";
      }).catch(err => {
        console.log("err=>", err)
        this.loadingInstance ? this.loadingInstance.close() : "";
      })
    }
  },
  created() {
    this.loadingInstance = this.$loading.service({
      lock: true,
      text: "Loading"
    });
    this.getItemList()
  }
}
</script>

<style lang="scss">
.title-desc {
  font-family: "PingFangSC-Medium";
  font-size: 24px;
  color: #0D1C28;
  line-height: 30px;
  border-bottom: 4px solid #0d1c28;
  padding-bottom: 15px;
}

a {
  color: #3E97DF;
  text-decoration: none;
}

.scenes-area-dialog {
  .el-dialog {
    margin-top: 12vh !important;
  }

  .el-dialog__title {
    font-weight: 700;
  }

  .el-dialog__body {
    max-height: 380px;
    overflow-y: auto;
  }

  .step-title {
    font-weight: 600;
    color: #0D1C28;
    line-height: 22px;
    font-size: 18px;
    margin-left: 5px;
  }

  .step-bgm {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-top: 1px;
  }

  .one-step {
    .one-step-icon {
      background: url('../../assets/imgs/one.png') no-repeat center;
      background-size: 100% 100%;
    }
  }

  .two-step {
    margin-top: 30px;

    .two-step-icon {
      background: url('../../assets/imgs/two.png') no-repeat center;
      background-size: 100% 100%;
    }
  }

  .three-step {
    margin-top: 30px;

    .three-step-icon {
      background: url('../../assets/imgs/three.png') no-repeat center;
      background-size: 100% 100%;
    }
  }

  .arrpove-list {
    .arrpove-items {
      color: #3E97DF;
      margin-top: 20px;
      font-size: 16px;

      .arrpove-name {
        display: inline-block;
        width: calc(100% - 225px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
        padding-right: 10px;
      }

      .arrpove-btns {
        display: inline-block;

        span {
          display: inline-block;
          width: 98px;
          height: 38px;
          line-height: 38px;
          background: rgba(62, 151, 223, 0.1);
          text-align: center;
          cursor: pointer;

          &+span {
            margin-left: 15px;
          }
        }
      }
    }
  }

  .step-tips {
    font-size: 12px;
    font-weight: 400;
    color: #777777;
    margin-left: 15px;

    .step-tips-icon {
      width: 12px;
      height: 12px;
      display: inline-block;
      // background: url('../../assets/imgs/icon-tips.png') no-repeat center;
      background-size: 100% 100%;
      margin-top: 1px;
      margin-right: 5px;
    }
  }

  .area-list {
    margin-top: 20px;

    .chose-area-item {
      display: inline-block;
      font-size: 16px;
      min-width: 64px;
      padding: 0 20px;
      height: 40px;
      margin-left: 10px;
      line-height: 40px;
      text-align: center;
      border-radius: 5px;
      color: #0D1C28;
      border: 2px solid #ffffff;
      cursor: pointer;
      overflow: hidden;
      position: relative;

      &.active {
        color: #3E97DF;
        border: 2px solid #3E97DF;

        span {
          position: absolute;
          width: 0;
          height: 0;
          bottom: 0;
          right: -2px;
          border-bottom: 30px solid #3E97DF;
          border-left: 30px solid transparent;
        }

        .active-icon {
          position: relative;
          left: -20px;
          top: 1px;
          color: #fff;
        }
      }
    }
  }
}
</style>
